module.exports = __webpack_public_path__ + "static/insert_mini_calendar_formula-1c051179e46852055dd35bf4e2294f17.png";